export const AdminFavouriteFilterReducer = (state = {}, action) => {
    if (action.type === 'GET_ADMIN_FAVOURITE_FILTER') {
      return {
        ...state,
        favouriteFilterDetails: action.payload,
      };
    } else {
      return state;
    }
  };
  